import SetPicture from '../set-pictures/set-picture.entity';
import { SosDeleteResponse } from '../sos-response';

export interface SetPictureDeleteResponse extends SosDeleteResponse {
	destroyed: {
		SetPicture: SetPicture[];
	};
}
